export const toRadians = (degrees: number) => degrees * (Math.PI / 180);